import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m2.21 1.43 8.15 8.15a1.55 1.55 0 0 1 .637-.137 1.55 1.55 0 0 1 1.55 1.55 1.55 1.55 0 0 1-1.55 1.55 1.55 1.55 0 0 1-1.55-1.55 1.55 1.55 0 0 1 .137-.637l-8.15-8.15 3.48 14.4a.6.6 0 0 0 .467.447l6.4 1.28-.209.209a.6.6 0 0 0 0 .848l3 3a.6.6 0 0 0 .848 0l7-7a.6.6 0 0 0 0-.848l-3-3a.6.6 0 0 0-.848 0l-.209.209-1.28-6.4a.6.6 0 0 0-.447-.467l-14.4-3.48zm16.5 10.4a.501.501 0 0 1 .355.855l-6.4 6.4a.501.501 0 0 1-.709-.709l6.4-6.4a.5.5 0 0 1 .354-.146" }, null, -1)
  ]))]))
}
export default { render: render }